import React from "react";
import Button from "@mui/material/Button";
import styled from "styled-components";
import { defaultValueGet } from "common/parameters_common";
import UserTypeSelect from "components/common/user/UserTypeSelect/UserTypeSelect";
import { USER_TYPE } from "constant/user/user.constant";

export type UserFormState = {
  un: string;
  email: string;
  firstName: string;
  lastName: string;
  uType: string;
  pw: string;
  pwRepeat: string;
};

type UserFormProps = {
  values?: Partial<UserFormState>;
  errorText?: string;
  isEditMode?: boolean;
  onChange: (
    field: keyof UserFormState,
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onReset: () => void;
};

const UserForm = ({
  values,
  errorText = "",
  isEditMode = false,
  onChange,
  onSubmit,
  onReset,
}: UserFormProps) => {
  const unDefault = defaultValueGet(values, "un", "");
  const emailDefault = defaultValueGet(values, "email", "");
  const firstNameDefault = defaultValueGet(values, "firstName", "");
  const lastNameDefault = defaultValueGet(values, "lastName", "");
  const uTypeDefault = defaultValueGet(values, "uType", USER_TYPE.EDITOR);
  const pwDefault = defaultValueGet(values, "pw", "");
  const pwRepeatDefault = defaultValueGet(values, "pwRepeat", "");

  return (
    <DivForm>
      <form onSubmit={onSubmit}>
        <DivField>
          <label htmlFor="un">Korisnicko ime</label>
          <Input
            id="un"
            type="text"
            placeholder="korisnicko ime"
            value={unDefault}
            onChange={onChange("un")}
          />
        </DivField>
        <DivField>
          <label htmlFor="email">Email</label>
          <Input
            id="email"
            type="text"
            placeholder="email"
            value={emailDefault}
            onChange={onChange("email")}
          />
        </DivField>
        <DivField>
          <label htmlFor="firstName">Ime</label>
          <Input
            id="firstName"
            type="text"
            placeholder="ime"
            value={firstNameDefault}
            onChange={onChange("firstName")}
          />
        </DivField>
        <DivField>
          <label htmlFor="lastName">Prezime</label>
          <Input
            id="lastName"
            type="text"
            placeholder="prezime"
            value={lastNameDefault}
            onChange={onChange("lastName")}
          />
        </DivField>
        <DivField>
          <UserTypeSelect
            defaultValue={uTypeDefault}
            onSelect={(value) =>
              onChange("uType")(
                { target: { value } } as React.ChangeEvent<
                  HTMLInputElement | HTMLSelectElement
                >
              )
            }
          />
        </DivField>
        <DivField>
          <label htmlFor="pw">
            Lozinka {isEditMode ? "(ostavi prazno ako se ne menja)" : ""}
          </label>
          <Input
            id="pw"
            type="password"
            value={pwDefault}
            onChange={onChange("pw")}
          />
        </DivField>
        <DivField>
          <label htmlFor="pwRepeat">Ponovljena lozinka</label>
          <Input
            id="pwRepeat"
            type="password"
            value={pwRepeatDefault}
            onChange={onChange("pwRepeat")}
          />
        </DivField>
        {errorText !== "" && <ErrorText>{errorText}</ErrorText>}
        <DivNav>
          <Button onClick={() => onReset()} type="button">
            Reset
          </Button>
          <Button type="submit">OK</Button>
        </DivNav>
      </form>
    </DivForm>
  );
};

const DivForm = styled.div`
  margin-top: 0.75rem;
`;

const DivField = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
`;

const DivNav = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 0.75rem;
`;

const Input = styled.input`
  width: 75%;
  padding: 0.45rem 0.6rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 0.95rem;
  margin-top: 0.7em;
`;

const ErrorText = styled.div`
  margin-top: 0.5rem;
  color: #b00020;
  font-weight: 600;
`;

export default UserForm;
